module.exports = __webpack_public_path__ + "src/img/zalando/floating-phones.a963f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/zalando/floating-phones.jpg
// module id = 261
// module chunks = 0